export default "__VITE_ASSET__Ig7mANMC__"